import { isInspector } from 'app/helpers/userRoles';
import { setCurrentApp } from 'app/store/auth';
import SynchronizeIcon from 'app/ui/icons/SynchronizeIcon';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Box, IconButton, Menu, MenuItem, SxProps, Tooltip } from '@mui/material';

import { RootState } from '../../../store/rootReducer';
import { getApps } from './Navigation/config';

const navbarHeight = 64;

const getStyles = (): { [key: string]: SxProps } => {
  return {
    iconButton: {
      height: navbarHeight,
      borderRadius: 0,
      marginLeft: 1,
    },
    buttonIndicator: {
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      height: '4px',
      borderRadius: '2px',
      zIndex: 10,
      background: '#ad3838',
    },
  };
};

export default function UserMenu() {
  const dispatch = useDispatch();
  const { user, currentApp } = useSelector((state: RootState) => state.auth);

  const styles = getStyles();

  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClick = (url: string, id: string, isExternal: boolean) => {
    if (!isExternal) {
      navigate(url);
    }

    if (isExternal) {
      window.location.href = url;
    }

    if (id !== 'admin-panel') {
      dispatch(setCurrentApp(id));
    }
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!user || isInspector(user)) {
    return null;
  }

  return (
    <>
      <Tooltip title="Switch Application">
        <IconButton aria-label="Switch Application" onClick={handleClick} sx={styles.iconButton}>
          <SynchronizeIcon />
          {open && <Box sx={styles.buttonIndicator}></Box>}
        </IconButton>
      </Tooltip>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        {getApps(user)
          .filter((item) => item?.id)
          .map((item) => (
            <MenuItem
              key={item.id}
              onClick={() => {
                handleMenuClick(item.homeUrl, item.id, item?.isExternal || false);
              }}
              disabled={item.id === currentApp && item.id !== 'admin-panel'}
            >
              {item.name}
            </MenuItem>
          ))}
      </Menu>
    </>
  );
}
